<template>
  <div class="content"><div class="banner"></div></div>
  <div class="upload">
    <div class="thehome">{{ $t("header.File_material_upload") }}</div>
    <div class="title">
      <el-form :model="form" size="small">
        <el-form-item label="上传图片视频文件">
          <el-upload
            class="upload-demo"
            action=""
            :http-request="fnUploadRequest"
            :show-file-list="true"
            :limit="10"
            :on-exceed="beyondFile"
            :on-success="handleVideoSuccess"
            :before-upload="beforeUploadVideo"
          >
            <div tabindex="0" class="el-upload-video">
              <i
                class="el-upload-video-i el-icon-plus avatar-uploader-icon"
              ></i>
            </div>
            <el-icon class="avatar-uploader-icon"><Plus /></el-icon>
            <div class="el-upload__tip" style="margin-left: 20px" slot="tip">
              {{ $t("header.Upload_pictures_and_video_files") }}
            </div>
          </el-upload>
          <!-- <el-input type="textarea" rows="5" v-model="urls"></el-input> -->
          <div
            class="alerturl"
            v-for="(item, index) in upload.urls"
            :key="index"
          >
            <div>
              {{ item }}
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import oss from "../utils/ali-oss.js";
import { reactive } from "vue";
const upload = reactive({
  urls: [],
  url: [],
});
const fnUploadRequest = async (e) => {
  oss.ossUploadFile(e);
};
const handleVideoSuccess = (response, file, fileList) => {
  if (response) {
    upload.urls.push(
      "http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/" + response.name
    );
    // console.log(this.urls, 12345);
  }
};
</script>

<style lang="scss" scoped>
@import "@/sass/index.scss";
.content {
  z-index: 0;
  max-width: 1468px;
  margin: 0 auto;
  height: 500px;
  position: relative;
  .banner {
    height: 100%;
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 0;
    background-image: url("https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
.upload {
  max-width: 1176px;
  margin: 0 auto;
  text-align: left;
  .thehome {
    margin: 28px 0 80px 0;
    @include fontstyle(#333, 24px, 800, auto);
  }
}
</style>
<style lang="scss">
.el-form-item {
  display: block !important;
  .el-form-item__label {
    text-align: left;
    margin-bottom: 25px;
    font-size: 24px;
    font-weight: 600;
  }
}
.el-form-item__content {
  display: block !important;
}
.upload-demo {
  display: flex !important;
  flex-direction: column !important;
  .el-upload {
    align-self: baseline !important;
  }
}
.alerturl {
  display: flex;
  flex-direction: column;
}
.m-upload {
  max-width: 1080px;
  margin: 50px auto;
  .title {
    font-size: 16px;
    color: #9fa0a0;
    display: flex;
    font-weight: bold;
  }
}
.uploadcontent {
  margin: 40px 0 0 40px;
}
.el-upload-video {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: block;
  background: url("https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/%E5%8A%A0%E5%8F%B7.png");
  background-size: cover;
  padding: 10px;
}
.el-upload-video-i {
  font-size: 36px;
  padding-top: 25px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
// .el-form-item__content {
//   display: flex;
//   flex-direction: column !important;
// }
.el-upload__tip {
  display: block;
}
</style>